import React from "react"
import Chip from "../../../../components/atoms/misc/Chip.atom"
import {
  backwardCompatibleClientProjectLabel,
  contrastTextColor,
} from "../../../../utils/strings.utils"
import Label from "../../../../components/atoms/Label.atom"

const BadgePreview = ({
  color = "var(--secondary-color)",
  chipLabel = "TEST",
  label = "Preview del indicador",
  ...props
}) => {
  const resolvedColor =
    getComputedStyle(document.documentElement)
      .getPropertyValue(color.match(/--[a-zA-Z0-9-]+/)?.[0])
      .trim() || color
  const textColor = contrastTextColor(resolvedColor, 150)
  const forId = `dropdown-input-color-${chipLabel.replace(/ /g, "-")}`
  return (
    <>
      <Label htmlFor={forId}>
        {" "}
        {label}
        {props.require ? " *" : ""}
        {props.optional ? " (Opcional)" : ""}
      </Label>
      <div className="flex-1 flex align-items-center h-full">
        <Chip
          id={forId}
          className="client-chip-preview text-white justify-content-center"
          template={
            <span
              className={`font-bold ${textColor === "black" ? "text-black" : "text-white"}`}
              style={{
                fontSize: "12px",
                lineHeight: "150%",
                color: "var(--text-color)",
              }}
            >
              {backwardCompatibleClientProjectLabel(chipLabel)}
            </span>
          }
          style={{
            backgroundColor: color,
            color: textColor,
            height: "22px",
            minWidth: "40px",
            width: "fit-content",
            padding: "0 7px",
            marginLeft: "5px",
            ...props.chipStyle,
          }}
        />
      </div>
    </>
  )
}

export default BadgePreview
